import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl, TextControl, ToggleControl, RangeControl, Flex, FlexBlock, FlexItem } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;
// Enable spacing control on the following blocks
const enableMinusMarginBlocks = [
    'core/column',
    'core/columns',
    'core/group',
    'core/heading',
    'core/paragraph',
    'core/image'

];


const withNegativeMargin = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        if (enableMinusMarginBlocks.includes(props.name)) {
            const e = document.querySelector('.components-input-control__input[min="0"]');
            e && e.setAttribute("min", "-999");
        }

        return (
            <BlockEdit { ...props } />
        );

    };
}, 'withNegativeMargin');

addFilter('editor.BlockEdit', 'extend-block-example/with-negative-margin', withNegativeMargin);